import { gql } from "@apollo/client";

export const GET_ALL_CARS = gql`
  query getAllCars($tokenGet: String!, $branchOffice: Int, $active: Boolean) {
    getCars(token: $tokenGet, branchOffice: $branchOffice, active: $active) {
      id
      licence_plate
      driver_firstname
      driver_lastname
      driver_email
      driver_phone
      sendSms
      storage_status
      note
      type
      vin
      active
      branchOffice {
        company
        id
      }
      carRenter {
        company
        id
      }
      carOwner {
        company
        id
      }
      storage_status
      storage {
        id
        number
        tyre_brand
        season
        note
        qty
        disk_type
        date
        speedometer
        thread
      }
      services {
        id
        date
      }
    }
  }
`;

// Paginated cars list (used on /admin/car)
export const GET_CARS_PAGINATED = gql`
  query getCarsPaginated(
    $tokenGet: String!
    $search: String
    $offset: Int
    $limit: Int
    $branchOffice: Int
    $active: Boolean
    $carOwnerId: ID
    $carRenterId: ID
    $storageStatus: Boolean
    $maVin: Boolean
    $storageSeason: String
    $storageDiskType: String
    $storageFrom: String
    $storageTo: String
    $maKontakt: Boolean
  ) {
    getCarsPaginated(
      token: $tokenGet
      search: $search
      offset: $offset
      limit: $limit
      branchOffice: $branchOffice
      active: $active
      carOwnerId: $carOwnerId
      carRenterId: $carRenterId
      storageStatus: $storageStatus
      maVin: $maVin
      storageSeason: $storageSeason
      storageDiskType: $storageDiskType
      storageFrom: $storageFrom
      storageTo: $storageTo
      maKontakt: $maKontakt
    ) {
      items {
        id
        licence_plate
        driver_firstname
        driver_lastname
        driver_email
        driver_phone
        sendSms
        storage_status
        note
        type
        vin
        active
        branchOffice {
          company
          id
        }
        carRenter {
          company
          id
        }
        carOwner {
          company
          id
        }
        storage_status
        storage {
          id
          number
          tyre_brand
          season
          note
          qty
          disk_type
          date
          speedometer
          thread
        }
        services {
          id
          date
        }
      }
      totalCount
      offset
      limit
    }
  }
`;

// Search cars for autocomplete (used on /admin/service/actions new record)
export const SEARCH_CARS = gql`
  query searchCars(
    $tokenGet: String!
    $search: String
    $offset: Int
    $limit: Int
    $branchOffice: Int
    $active: Boolean
  ) {
    getCars(
      token: $tokenGet
      search: $search
      offset: $offset
      limit: $limit
      branchOffice: $branchOffice
      active: $active
    ) {
      id
      licence_plate
      carOwner {
        id
        company
      }
      branchOffice {
        id
        company
      }
    }
  }
`;

// Search products/services for autocomplete (e.g. service action detail add-item)
export const SEARCH_PRODUCTS = gql`
  query searchProducts(
    $tokenGet: String!
    $search: String
    $offset: Int
    $limit: Int
  ) {
    getProducts(
      token: $tokenGet
      offset: $offset
      limit: $limit
      search: $search
    ) {
      items {
        id
        name
        code
        supplier
        price_purchase
        price_sale
        tax
        priceLists {
          id
          price_sale
          carOwner {
            id
          }
        }
      }
      totalCount
      offset
      limit
    }
  }
`;
export const GET_ALL_USERS = gql`
  query getAllUsers($tokenGet: String!) {
    getUserById(token: $tokenGet) {
      id
      firstname
      lastname
      branchOffice {
        id
        firstname
        lastname
        company
        street
        city
        zip
        phone
        email
        ic
        dic
        ic_dph
      }
      email
      active
    }
  }
`;
export const GET_CAR_BY_ID = gql`
  query getCarById($carId: ID, $tokenGet: String!) {
    getCars(id: $carId, token: $tokenGet) {
      id
      licence_plate
      driver_firstname
      driver_lastname
      driver_email
      driver_phone
      sendSms
      storage_status
      note
      type
      vin
      active
      branchOffice {
        company
        id
      }
      carRenter {
        company
      }
      carOwner {
        company
      }
      storage_status
      storage {
        id
        number
        tyre_brand
        size
        speed
        capacity
        thread
        season
        qty
        focus
        note
        disk_type
        date
        speedometer
      }
      reservations {
        id
        from_time
        date
        note
      }
      services {
        id
        date
        status
      }
    }
  }
`;
export const GET_OWNER_CARS = gql`
  query getCarById($carOwnerId: ID, $tokenGet: String!) {
    getCars(carOwnerId: $carOwnerId, token: $tokenGet) {
      id
      licence_plate
      driver_firstname
      driver_lastname
      driver_email
      driver_phone
      sendSms
      storage_status
      note
      active
      branchOffice {
        company
        id
      }
      carRenter {
        company
      }
      carOwner {
        company
      }
      storage_status
      storage {
        id
        number
        tyre_brand
        qty
        thread
        season
        disk_type
        speedometer
      }
      reservations {
        id
        from_time
        date
        note
      }
    }
  }
`;
export const GET_BRANCH_OFICCES = gql`
  query getBranchOficces($tokenGet: String!) {
    getBranchOficces(token: $tokenGet) {
      id
      active
      firstname
      lastname
      company
      street
      city
      zip
      phone
      email
      ic
      dic
      ic_dph
      devices {
        id
        first_reservation
        last_reservation
      }
    }
  }
`;
export const GET_CAR_OWNERS = gql`
  query getCarOwners($tokenGet: String!) {
    getCarOwners(token: $tokenGet) {
      id
      active
      firstname
      lastname
      company
      street
      city
      zip
      phone
      email
      ic
      dic
      ic_dph
      reservation_emails
      invoice_emails
      invoice_maturity
      bonus
      code
      pickup
    }
  }
`;

export const GET_CAR_OWNER_BY_ID = gql`
  query getCarOwnerById($ownerId: ID!, $tokenGet: String!) {
    getCarOwners(id: $ownerId, token: $tokenGet) {
      id
      active
      firstname
      lastname
      company
      street
      city
      zip
      phone
      email
      ic
      dic
      ic_dph
      reservation_emails
      invoice_emails
      invoice_maturity
      bonus
      code
      pickup
    }
  }
`;
export const GET_CAR_RENTERS = gql`
  query getCarRenters($tokenGet: String!) {
    getCarRenters(token: $tokenGet) {
      id
      active
      firstname
      lastname
      company
      street
      city
      zip
      phone
      email
      ic
      dic
      ic_dph
      reservation_emails
    }
  }
`;

export const GET_RENTER_CARS = gql`
  query getCarById($carRenterId: ID, $tokenGet: String!) {
    getCars(carRenterId: $carRenterId, token: $tokenGet) {
      id
      licence_plate
      driver_firstname
      driver_lastname
      driver_email
      driver_phone
      sendSms
      storage_status
      note
      active
      branchOffice {
        company
        id
      }
      carRenter {
        company
      }
      carOwner {
        company
      }
      storage_status
      storage {
        id
        number
        tyre_brand
        qty
        thread
        season
        disk_type
        speedometer
      }
      reservations {
        id
        from_time
        date
        note
      }
    }
  }
`;
export const GET_RESERVATIONS = gql`
  query getReservations(
    $tokenGet: String!
    $branchOfficeId: ID!
    $fromDate: String
    $toDate: String
  ) {
    getReservations(
      token: $tokenGet
      branchOfficeId: $branchOfficeId
      fromDate: $fromDate
      toDate: $toDate
    ) {
      id
      number
      from_time
      to_time
      status
      date
      pickup
      note
      car {
        id
        licence_plate
        type
        vin
        driver_firstname
        driver_lastname
        driver_email
        driver_phone
        storage_status
        note
        sendSms
        carOwner {
          id
          company
        }
        carRenter {
          id
          company
        }
        storage {
          id
          number
          season
          tyre_brand
          size
          disk_type
          thread
        }
      }
      device {
        id
        first_reservation
        last_reservation
        branchOffice {
          id
          lastname
          firstname
        }
      }
    }
  }
`;
/**
 * Hladanie rezervacii na serveri, v CELOM archive pobocky.
 *
 * Kalendar si od 21.9.2026 tahá len zobrazeny tyzden, takze hladanie nad tym,
 * co ma prehliadac v pamati, nikdy nenajde auto objednane na iny mesiac.
 * Tento dopyt hlada v databaze a vracia len to, co sedi, cize sa nevraciame
 * k tahaniu celeho archivu (14 tisic zaznamov, 7,5 MB).
 *
 * Polia su schvalne uzke: vysledok je zoznam na preklik, nie kalendar.
 */
export const GET_RESERVATIONS_SEARCH = gql`
  query getReservations(
    $tokenGet: String!
    $branchOfficeId: ID!
    $search: String
    $limit: Int
  ) {
    getReservations(
      token: $tokenGet
      branchOfficeId: $branchOfficeId
      search: $search
      limit: $limit
    ) {
      id
      number
      date
      from_time
      to_time
      pickup
      note
      device {
        id
      }
      car {
        id
        licence_plate
        type
        driver_firstname
        driver_lastname
        carOwner {
          id
          company
        }
        carRenter {
          id
          company
        }
      }
    }
  }
`;
export const GET_POSLEDNE_REZERVACIE = gql`
  query getPosledneRezervacie(
    $tokenGet: String!
    $branchOfficeId: ID
    $limit: Int
  ) {
    getPosledneRezervacie(
      token: $tokenGet
      branchOfficeId: $branchOfficeId
      limit: $limit
    ) {
      id
      date
      from_time
      to_time
      status
      pickup
      note
      car {
        id
        licence_plate
        type
        driver_firstname
        driver_lastname
        carOwner {
          id
          company
        }
      }
      device {
        id
        branchOffice {
          id
          company
        }
      }
    }
  }
`;
export const GET_DEVICES_BY_BRANCHOFFICE_ID = gql`
  query getDevicesByBranchOfficeId($tokenGet: String!, $branchOffice: ID!) {
    getDevicesByBranchOfficeId(token: $tokenGet, branchOffice: $branchOffice) {
      id
      first_reservation
      last_reservation
    }
  }
`;
export const GET_RESERVATIONS_BY_DATE = gql`
  query getReservationsByDate(
    $tokenGet: String!
    $fromDate: String!
    $toDate: String!
  ) {
    getReservationsByDate(
      token: $tokenGet
      fromDate: $fromDate
      toDate: $toDate
    ) {
      id
      number
      from_time
      to_time
      status
      date
      pickup
      note
      car {
        id
        licence_plate
        branchOffice {
          id
          lastname
          firstname
        }
      }
      device {
        id
        branchOffice {
          id
          lastname
          firstname
        }
        first_reservation
        last_reservation
      }
    }
  }
`;
export const GET_PRODUCTS = gql`
  query getProducts(
    $tokenGet: String!
    $offset: Int
    $limit: Int
    $search: String
    $typ: String
    $dodavatel: String
    $cena: String
  ) {
    getProducts(
      token: $tokenGet
      offset: $offset
      limit: $limit
      search: $search
      typ: $typ
      dodavatel: $dodavatel
      cena: $cena
    ) {
      items {
        id
        name
        price_purchase
        price_sale
        qty
        tax
        type
        code
        supplier
        custom_product
        stockMove {
          date
          type
          qty
        }
        priceLists {
          id
          price_sale
          carOwner {
            id
            company
          }
        }
      }
      totalCount
      offset
      limit
    }
  }
`;

// Backwards-compatible alias for older imports
export const GET_PRODUCTS_PAGINATED = GET_PRODUCTS;

export const GET_TAXES = gql`
  query getTaxes($tokenGet: String!) {
    getTaxes(token: $tokenGet) {
      id
      name
      value
    }
  }
`;

export const GET_PRICELIST = gql`
  query getPricelist($carOwner: ID, $tokenGet: String!) {
    getPricelist(carOwner: $carOwner, token: $tokenGet) {
      id
      price_sale
      carOwner {
        company
      }
      product {
        name
      }
    }
  }
`;
export const GET_SERVICE_ACTIONS = gql`
  query getServiceActions(
    $tokenGet: String!
    $status: String
    $id: ID
    $offset: Int
    $limit: Int
    $search: String
    $branchOfficeId: ID
    $carOwnerId: ID
    $carRenterId: ID
    $dateFrom: String
    $dateTo: String
    $sumaOd: Float
    $sumaDo: Float
    $cisloFaktury: String
  ) {
    getServiceActions(
      token: $tokenGet
      status: $status
      id: $id
      offset: $offset
      limit: $limit
      search: $search
      branchOfficeId: $branchOfficeId
      carOwnerId: $carOwnerId
      carRenterId: $carRenterId
      dateFrom: $dateFrom
      dateTo: $dateTo
      sumaOd: $sumaOd
      sumaDo: $sumaDo
      cisloFaktury: $cisloFaktury
    ) {
      records {
        id
        status
        date
        mileage
        note
        authorization_code
        email_send
        invoiced
        invoiceSendStatus
        invoiceSendStatusEcon
        invoice_number
        payment_type
        invoice_due_date
        exportBlStatus
        ayvens_contract_number
        ayvens_order_status
        ayvens_response
        ayvens_approval_response
        exportBlDate
        invoice_issue_date
        invoiceId
        total
        branchOffice {
          id
          company
          street
          city
          zip
          phone
          email
          ic
          dic
          ic_dph
        }
        car {
          id
          licence_plate
          driver_firstname
          driver_lastname
          driver_phone
          type
          vin
          storage {
            id
            number
            tyre_brand
            size
            speed
            capacity
            thread
            season
            qty
            focus
            note
            disk_type
            date
            speedometer
          }
          carRenter {
            id
            company
          }
        }
        carOwner {
          id
          company
          street
          city
          zip
          phone
          email
          ic
          dic
          ic_dph
          bonus
          invoice_emails
          code
        }
        items {
          id
          product_name
          code
          qty
          price_purchase
          price_sale
          price_total
          tax
          price_sale_tax
          price_total_tax
          note
        }
      }
      total
    }
  }
`;
export const GET_STORAGE_LIST = gql`
  query getStorageList($id: ID, $tokenGet: String!) {
    getStorageList(id: $id, token: $tokenGet) {
      id
      number
      tyre_brand
      size
      speed
      qty
      capacity
      thread
      season
      focus
      note
      date
      disk_type
      speedometer
      car {
        id
        licence_plate
        driver_firstname
        driver_lastname
        carOwner {
          id
          company
        }
        carRenter {
          id
          company
        }
        branchOffice {
          id
          company
        }
      }
      reservation {
        id
        date
      }
    }
  }
`;
export const GET_STORAGE_SEARCH = gql`
  query getStorageSearch(
    $tokenGet: String!
    $search: String
    $limit: Int
    $offset: Int
    $branchOfficeId: Int
    $carOwnerId: Int
    $carRenterId: Int
    $season: String
    $diskType: String
    $dateFrom: String
    $dateTo: String
  ) {
    getStorageSearch(
      token: $tokenGet
      search: $search
      limit: $limit
      offset: $offset
      branchOfficeId: $branchOfficeId
      carOwnerId: $carOwnerId
      carRenterId: $carRenterId
      season: $season
      diskType: $diskType
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      total
      records {
        id
        number
        tyre_brand
        size
        speed
        qty
        thread
        season
        note
        date
        disk_type
        car {
          id
          licence_plate
          vin
          type
          driver_firstname
          driver_lastname
          carOwner {
            id
            company
          }
          carRenter {
            id
            company
          }
          branchOffice {
            id
            company
          }
        }
      }
    }
  }
`;
export const GET_BRANCH_OFFICES = gql`
  query getBranchOficces($tokenGet: String!) {
    getBranchOficces(token: $tokenGet) {
      id
      active
      firstname
      lastname
      company
      street
      city
      zip
      phone
      email
      send_reservation_email
      ic
      dic
      ic_dph
      note
      devices {
        id
        first_reservation
        last_reservation
      }
      cars {
        id
        licence_plate
        driver_firstname
        driver_lastname
        driver_phone
        driver_email
        note
        sendSms
        active
      }
    }
  }
`;
